import { OperationContext, useMutation } from 'urql';
import {
  CreateResponseTaskInput,
  CreateResponseTaskMutation,
  DeleteFileTaskResponseMutation,
  MutationDeleteFileTaskResponseArgs,
  MutationRemoveTaskResponseArgs,
  MutationTaskChangeStateArgs,
  MutationUpdateTaskStateArgs,
  RemoveTaskResponseMutation,
  TaskChangeStateMutation,
  UpdateTaskStateMutation
} from 'gql/graphql';
import {
  CREATE_RESPONSE_TASK,
  DELETE_FILE_TASK_RESPONSE,
  REMOVE_TASK_RESPONSE,
  TASK_CHANGE_STATE,
  UPDATE_TASK_STATE
} from './graphql';
import { useContext } from 'react';
import { CreateTaskResponseContext, LoanContext, ProgressContext, TasksContext } from 'scenes/Private/Dashboard/Dashboard';

export const useCreateResponseTask = (query?: any) => {
  const tasks: any = useContext(TasksContext);
  const loan: any = useContext(LoanContext);

  const { setValue: setCreateResponseTask }: any = useContext(CreateTaskResponseContext);
  const loanProgress: any = useContext(ProgressContext);

  const [{ data, fetching, error }, execute] = useMutation<CreateResponseTaskMutation>(
    query || CREATE_RESPONSE_TASK
  );
  return {
    execute: async (data: CreateResponseTaskInput) => {
      setCreateResponseTask('loading');
      const result = await execute({
        createResponseTaskInput: {
          ...data,
          loanProgress
        }
      }, {
        sentryTask: tasks.find((item: any) => item._id === data.task),
        sentryLoan: loan
      });
      setCreateResponseTask('success');
      setTimeout(() => {
        setCreateResponseTask('idle');
      }, 1000);
      return result;
    },
    data: data?.createResponseTask,
    fetching,
    error
  };
};

export const useDeleteFileResponse = (query?: any) => {
  const [results, execute] = useMutation<DeleteFileTaskResponseMutation>(
    query || DELETE_FILE_TASK_RESPONSE
  );

  return {
    execute: (data: MutationDeleteFileTaskResponseArgs) => execute(data),
    data: results.data?.DeleteFileTaskResponse,
    ...results
  };
};

export const useTaskChangeState = (query?: any) => {
  const [results, execute] = useMutation<TaskChangeStateMutation>(
    query || TASK_CHANGE_STATE
  );

  return {
    execute: (data: MutationTaskChangeStateArgs) => execute(data),
    data: results.data?.TaskChangeState,
    ...results
  };
};

export const useUpdateTaskState = (query?: any) => {
  const [results, execute] = useMutation<UpdateTaskStateMutation>(
    query || UPDATE_TASK_STATE
  );

  return {
    execute: (variables: MutationUpdateTaskStateArgs) => execute(variables),
    data: results.data?.UpdateTaskState,
    ...results
  };
};

export const useRemoveTaskResponse = (query?: any) => {
  const [results, execute] = useMutation<RemoveTaskResponseMutation>(
    query || REMOVE_TASK_RESPONSE
  );

  return {
    execute: (data: MutationRemoveTaskResponseArgs) => execute(data),
    data: results.data?.RemoveTaskResponse,
    ...results
  };
};
